import { Box } from '@factorialco/deprecated-design-system'

import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

import { AppleCalendar } from './AppleCalendar'
import { Ats } from './Ats'
import { AtsCareersPage } from './AtsCareersPage'
import { AtsIdealdisc } from './AtsIdealdisc'
import { AtsWhatsapp } from './AtsWhatsapp'
import { Breezy } from './Breezy'
import { Cobee } from './Cobee'
import { Competencies } from './Competencies'
import { CompetenciesV2 } from './CompetenciesV2'
import { Complaints } from './Complaints'
import { Desky } from './Desky'
import { DocumentTemplates } from './DocumentTemplates'
import { EmployeeChatWhatsApp } from './EmployeeChatWhatsApp'
import { EmployeeOnboarding } from './EmployeeOnboarding'
import { Enps } from './Enps'
import { Expenses } from './Expenses'
import { ExpensesV2 } from './ExpensesV2'
import { Finance } from './Finance'
import { Gmail } from './Gmail'
import { Goals } from './Goals'
import { GoogleCalendar } from './GoogleCalendar'
// Integrations
import { GrowthPlans } from './GrowthPlans'
import { Indeed } from './Indeed'
import { Join } from './Join'
import { LinkedIn } from './LinkedIn'
import { LinkedInLimitedListings } from './LinkedInLimitedListings'
import { Outlook } from './Outlook'
import { OutlookCalendar } from './OutlookCalendar'
import { Payflow } from './Payflow'
import { PayrollBundle } from './PayrollBundle'
import { PerformanceV2 } from './PerformanceV2'
import { Recruitee } from './Recruitee'
import { ShiftManagement } from './ShiftManagement'
import { Slack } from './Slack'
import { Surveys } from './Surveys'
import { TasksManagement } from './TasksManagement'
import { TimeTracking } from './TimeTracking'
import { Trainings } from './Trainings'
import { Zapier } from './Zapier'

interface BodyProps {
  id: string
}

const DescriptionBody = ({ id }: BodyProps) => {
  switch (id) {
    // Apps
    case 'ats':
      return <Ats />

    case 'ats_careers_page':
      return <AtsCareersPage />

    case 'join':
      return <Join />
    case 'payroll_bundle':
      return <PayrollBundle />

    case 'shift_management':
      return <ShiftManagement />

    case 'tasks_management':
      return <TasksManagement />

    case 'time_tracking':
      return <TimeTracking />

    case 'expenses':
      return <Expenses />

    case 'expenses_v2':
      return <ExpensesV2 />

    case 'finance':
      return <Finance />

    case 'surveys':
      return <Surveys />

    case 'performance_v2':
      return <PerformanceV2 />

    case 'goals':
      return <Goals />

    case 'trainings_custom_table':
      return <Trainings />

    case 'growth_plans_custom_table':
      return <GrowthPlans />

    case 'competencies_custom_table':
      return <Competencies />

    case 'competencies':
      return <CompetenciesV2 />

    case 'complaints':
      return <Complaints />

    case 'document_templates':
      return <DocumentTemplates />

    case 'employee_onboarding':
      return <EmployeeOnboarding />

    case 'enps':
      return <Enps />

    // Integrations

    case 'google_calendar':
      return <GoogleCalendar />

    case 'apple_calendar':
      return <AppleCalendar />

    case 'outlook_calendar':
      return <OutlookCalendar />

    case 'zapier':
      return <Zapier />

    case 'slack':
      return <Slack />

    case 'gmail':
      return <Gmail />

    case 'outlook':
      return <Outlook />

    case 'breezy':
      return <Breezy />

    case 'recruitee':
      return <Recruitee />

    case 'indeed':
      return <Indeed />

    case 'linkedin':
      return <LinkedIn />

    case 'linkedin_limited_listings':
      return <LinkedInLimitedListings />

    case 'cobee':
      return <Cobee />

    case 'payflow':
      return <Payflow />

    case 'desky':
      return <Desky />

    case 'ats_whatsapp':
      return <AtsWhatsapp />

    case 'employee_chat_on_whatsapp':
      return <EmployeeChatWhatsApp />

    case 'ats_ideal_disc_integration':
      return <AtsIdealdisc />

    default:
      return null
  }
}

interface Props {
  subscriptionAddon: SubscriptionAddon
}

const AppDescription = ({ subscriptionAddon }: Props) => {
  const { id } = subscriptionAddon.attributes

  return (
    <Box paddingTop="s32" paddingBottom="s16" gap="s16">
      <DescriptionBody id={id} />
    </Box>
  )
}

export default AppDescription
